'use client';

import { useEffect, useState } from 'react';
import { reportClientError } from '@/lib/clienterr';

// Friendly fallback for any uncaught client render error. Auto-reloads ONCE
// (budgeted) — a stale bundle recovers on a fresh fetch; a persistent error
// stops reloading and leaves a manual button instead of looping forever.
export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const [looping, setLooping] = useState(false);

  useEffect(() => {
    reportClientError('error-boundary', error);
    let willReload = false;
    try {
      const KEY = 'wow:err-reload';
      const now = Date.now();
      const [c, t] = (sessionStorage.getItem(KEY) || '0:0').split(':');
      let count = Number(c) || 0;
      const ts = Number(t) || 0;
      if (now - ts > 30000) count = 0; // 30s stable → allow one auto-reload again
      if (count < 1) {
        sessionStorage.setItem(KEY, `${count + 1}:${now}`);
        willReload = true;
      }
    } catch {
      willReload = true;
    }
    if (!willReload) {
      setLooping(true);
      return;
    }
    const timer = setTimeout(() => window.location.reload(), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <main className="mx-auto flex min-h-[70dvh] max-w-sm flex-col items-center justify-center gap-3 px-4 text-center">
      <p className="text-base font-semibold">頁面載入發生問題</p>
      <p className="text-sm text-zinc-500">
        {looping
          ? '自動重整仍未恢復。請關閉 App 再重新開啟(或下拉重新整理)。'
          : '正在自動重新整理…若未恢復,請手動重新整理頁面。'}
      </p>
      <button
        onClick={() => reset()}
        className="rounded-xl bg-brand px-5 py-2.5 text-sm font-semibold text-white"
      >
        重新載入
      </button>
    </main>
  );
}
